import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { Image } from '../../../';

const SwatchesPanel = ({ data }) => {
	const [activeTab, setActiveTab] = useState(0);

	const renderSwatchList = (swatches) => (
		<List
			bullets='none'
			className='swatchesPanel-list mt-2.5 flex flex-row flex-wrap justify-center'
		>
			{swatches.map((image, index) => (
				<li
					key={index}
					className={`my-1 max-w-4/12 flex-4/12 px-1 sm:mx-1 sm:min-w-[calc(25%-10px)] sm:max-w-full sm:flex-none sm:px-0 md:min-w-[calc(20%-10px)] lg:mx-2.5 lg:min-w-[calc(11.1%-20px)] ${swatches.length < 9 ? 'sm:max-w-[calc(25%-10px)] sm:flex-[1_1_calc(25%-10px)] md:max-w-[calc(20%-10px)] md:flex-[1_1_calc(20%-10px)] lg:max-w-[180px] lg:flex-1' : ''}`}
				>
					{(image.file?.url || image.image?.url) && (
						<div className='mb-2.5 border border-gray-15 p-2.5'>
							<Image
								data={image.file?.url ? image : { file: image.image }}
								className='mx-auto !block sm:h-[95px] lg:h-[145px] xl:h-[160px]'
								objectFit='contain'
							/>
						</div>
					)}

					{image.image_title && <p className='text-center'>{image.image_title}</p>}
				</li>
			))}
		</List>
	);

	const renderTabsList = (tabs) => (
		<List
			bullets='none'
			className='mb-7 flex flex-row justify-center overflow-auto border-b border-b-gray-15'
		>
			{tabs.map((tab, index) => (
				<li
					key={index}
					className={`relative flex-none ${index > 0 ? 'ml-5 pl-5 before:absolute before:bottom-4 before:left-0 before:top-4 before:w-px before:bg-gray-15 before:content-[""] xl:ml-10 xl:pl-10' : ''}`}
				>
					<button
						className={`border-b-4 py-4 font-semibold ${activeTab === index ? 'border-b-primary text-black' : 'border-b-transparent text-gray-60'}`}
						onClick={() => onTabClick(index)}
					>
						{tab.options_title || tab.heading}
					</button>
				</li>
			))}
		</List>
	);

	const onTabClick = (index) => setActiveTab(index);

	return (
		<div className='swatchesPanel'>
			{data?.length > 1 && renderTabsList(data)}

			{data?.[0] &&
				data?.map((swatch, index) => {
					if (index !== activeTab) return null;

					return (
						<div key={index}>
							{swatch.heading && <h3 className='text-center'>{swatch.heading}</h3>}
							{swatch.options_images?.[0] && renderSwatchList(swatch.options_images)}
							{swatch.swatches?.[0] && renderSwatchList(swatch.swatches)}

							{swatch.row_2_heading && <h3 className='mt-6 text-center'>{swatch.row_2_heading}</h3>}
							{swatch.row_2_swatches?.[0] && renderSwatchList(swatch.row_2_swatches)}
						</div>
					);
				})}
		</div>
	);
};

SwatchesPanel.propTypes = {
	data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default SwatchesPanel;
